/**
 * Application constants.
 */

export const FUEL_LEVELS = [
  { value: 'FULL', label: 'Full' },
  { value: 'THREE_QUARTER', label: '3/4' },
  { value: 'TWO_THIRD', label: '2/3' },
  { value: 'HALF', label: '1/2' },
  { value: 'ONE_THIRD', label: '1/3' },
  { value: 'QUARTER', label: '1/4' },
  { value: 'EMPTY', label: 'Empty' },
];

export const AIRCRAFT_STATUS = {
  SERVICEABLE: 'SERVICEABLE',
  UNSERVICEABLE: 'UNSERVICEABLE',
};

export const DEFECT_STATUS = {
  OPEN: 'OPEN',
  UNSURE: 'UNSURE',
  RESOLVED: 'RESOLVED',
};

export const BILLING_STATUS = {
  DRAFT: 'DRAFT',
  ISSUED: 'ISSUED',
  PAID: 'PAID',
};

export const BILLING_BASIS = {
  BLOCK_TIME: 'BLOCK_TIME',
  FLIGHT_TIME: 'FLIGHT_TIME',
};

export const OIL_UNITS = {
  gallons: 'gallons',
  quarts: 'quarts',
  pints: 'imperial pints',
  litres: 'litres',
};

/** Fuel volume/mass units for tank capacity and uplift. */
export const FUEL_UNITS = [
  { value: 'usg',    label: 'US Gallons (USG)' },
  { value: 'impgal', label: 'Imp Gallons' },
  { value: 'litres', label: 'Litres (L)' },
  { value: 'lb',     label: 'Pounds (lb)' },
  { value: 'kg',     label: 'Kilograms (kg)' },
];

/** Fuel flow rate units (per hour), set per aircraft. */
export const FUEL_FLOW_UNITS = [
  { value: 'PPH', label: 'PPH (lb/hr)' },
  { value: 'KPH', label: 'KPH (kg/hr)' },
  { value: 'GPH', label: 'GPH (gal/hr)' },
];

export const USER_ROLES = {
  ADMIN: 'admin',
  OWNER: 'owner',
  PILOT: 'pilot',
  ALIAS: 'alias',
};

export const MAINTENANCE_TYPES = {
  FIFTY_HR: '50HR',
  ANNUAL: 'ANNUAL',
  OIL_CHANGE: 'OIL_CHANGE',
  OTHER: 'OTHER',
};

export const FIFTY_HR_THRESHOLD = 50;

export const FLIGHT_STATUS = {
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  FLOWN: 'FLOWN',
};

/** @deprecated Use FLIGHT_STATUS instead */
export const BOOKING_STATUS = FLIGHT_STATUS;

export const LICENCE_TYPES = ['PPL', 'CPL', 'ATPL'];

export const RATING_CATEGORIES = ['SEP', 'MEP', 'IR', 'TYPE_RATING'];

export const FLIGHT_CATEGORIES = {
  VFR: 'VFR',
  MVFR: 'MVFR',
  IFR: 'IFR',
  LIFR: 'LIFR',
};

export const FLIGHT_CATEGORY_COLOURS = {
  VFR: 'badge-green',
  MVFR: 'badge-blue',
  IFR: 'badge-red',
  LIFR: 'badge-magenta',
};

export const FUEL_ACCOUNT_TYPES = ['ACCOUNT', 'OVERSEAS_ACCOUNT', 'NON_ACCOUNT'];

export const TIME_FORMATS = {
  HMMSS: 'HH:MM:SS',
  DECIMAL: 'DECIMAL',
};

export const MAX_PASSENGERS = 5;
export const MAX_DEFECTS = 10;
